export const menuConfig = [
  {
    label: "CEN-KM",
    href: "/cenkm/digitizer",
    activePath: "/cenkm",
    dropdown: null
    // dropdown: [
    //   { label: "Digitizer", href: "/cenkm/digitizer" },
    //   { label: "Reconstruction", href: "/cenkm/reconstruction" }
    // ]
  }
];
